import { SKTRadioButton, SKTRadioOption } from "./SKTRadioButton";

export const SKTCarShipment = ({ data }) => {
  const id = "iPCarType";
  return (
    <SKTRadioButton id={id} data={data} label="Ajoneuvon tyyppi">
      <SKTRadioOption id={id} data={data} value="1" label="Henkilöauto" />
      <SKTRadioOption
        id={id}
        data={data}
        value="2"
        label="Pakettiauto tai maasturi"
      />
      <SKTRadioOption id={id} data={data} value="3" label="Suuri pakettiauto" />
    </SKTRadioButton>
  );
};
